module.exports = __webpack_public_path__ + "htmlPostit.svg?7bc0460df0b5e6856952769e6e9aa92f";